/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import FormLabel from 'components/pages/ResourceSetting/Widgets/FormLabel';
import ProductRangeRadio from 'components/pages/ResourceSetting/Widgets/ProductRangeRadio';
import Styles from './index.module.css';

export default function ProductRangeField({
  value,
  onChange,
  contentFeed,
  setContentFeed,
  ...props
}) {
  return (
    <div className={Styles.mainContainer} {...props}>
      <FormLabel title="投放商品" description="建議投放「全館商品」" />
      <ProductRangeRadio
        value={value}
        onChange={onChange}
        contentFeed={contentFeed}
        setContentFeed={setContentFeed}
      />
    </div>
  );
}

ProductRangeField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  setContentFeed: PropTypes.func,
  contentFeed: PropTypes.object,
};

ProductRangeField.defaultProps = {
  value: '',
  onChange: () => {},
  setContentFeed: () => {},
  contentFeed: {},
};
